import { Router, ActivatedRoute } from '@angular/router';
import { TaskService } from '../../service/task.service';
import { HttpParams } from '@angular/common/http';
import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { Task } from '../../model/task.model';
import { Formation } from '../../model/formation.model';
import { ExerciceSheetService } from '../../service/exerciceSheet.service';

@Component({
  selector: 'app-exercice-assigned',
  templateUrl: './exercice-assigned.component.html',
  styleUrls: ['./exercice-assigned.component.scss']
})
export class ExerciceAssignedComponent implements OnChanges {

  @Input() formationId: Formation;
  @Input() title;
  @Input() typeExercice: string;
  @Input() session!: number;
  /** Incrémenté par le parent pour forcer un rechargement (plus fiable que ViewChild.reload). */
  @Input() reloadToken: number;
  @Input() canDeleteTask: boolean = false;
  @Output() hasTaskToDoOutput = new EventEmitter();
  @Output() taskDeleted = new EventEmitter();
  taskSheetToDo: Task[] = [];

  constructor(
    private taskService: TaskService,
    private router: Router,
    private route: ActivatedRoute,
    private exerciceSheetService: ExerciceSheetService
  ) { }

  ngOnChanges(changes: SimpleChanges) {
    if (this.formationId && (changes['formationId'] || changes['typeExercice'] || changes['session'] || changes['reloadToken'])) {
      this.getAssignedSheetList();
    }
  }

  // Méthode publique pour forcer un rechargement depuis le parent
  reload() {
    this.getAssignedSheetList();
  }

  getAssignedSheetList() {
    // On charge toutes les tasks open de la formation pour ce type.
    // Si une session est fournie, on garde : tasks de cette session + tasks sans session
    // (les sans session apparaissent chez l'élève mais étaient invisibles avec le filtre strict).
    let params = new HttpParams()
      .set('salt', Math.random().toString())
      .set('what_model', 'exercice')
      .set('for_model', 'formation')
      .set('for_entity_id', this.formationId.toString())
      .set('status', 'open')
      .set('tasks_exercice__type_exercice', this.typeExercice);

    this.taskService.getTasks(params).subscribe(data => {
      if (data.results) {
        let results = data.results;
        if (this.session) {
          const sessionId = Number(this.session);
          results = results.filter(task => {
            const taskSessionId = this.extractSessionId(task);
            return taskSessionId == null || taskSessionId === sessionId;
          });
        }
        this.taskSheetToDo = results;
        this.hasTaskToDoOutput.emit(this.taskSheetToDo.length > 0);
      }
    })
  }

  /** session API = URL hypermedia ou objet { id } */
  private extractSessionId(task: any): number | null {
    const session = task?.session;
    if (session == null || session === '') {
      return null;
    }
    if (typeof session === 'object' && session.id != null) {
      return Number(session.id);
    }
    if (typeof session === 'string') {
      const parts = session.split('?')[0].split('/').filter(Boolean);
      const last = parts[parts.length - 1];
      return /^\d+$/.test(last) ? Number(last) : null;
    }
    if (typeof session === 'number') {
      return session;
    }
    return null;
  }

  deleteTask(task) {
    this.taskService.patchTask(task.id, { status: 'deleted' }).subscribe(result => {
      this.taskSheetToDo = this.taskSheetToDo.filter(_task => _task.id !== task.id)
      this.taskDeleted.emit(task);
    })
  }
}
